import React, { useState } from 'react';
import styles from './HelpModal.module.css';

export const HelpModal = ({ showHelp, setShowHelp }) => {
  if (!showHelp) return null; // Stay hidden unless clicked

  return (
    <>
      <div className={styles.modalOverlay} onClick={() => setShowHelp(false)} />
      <div className={styles.instructionsModal}>
        <div className={styles.header}>
          <h3>How to Use Talent Track</h3>
          <button className={styles.closeButton} onClick={() => setShowHelp(false)}>
            ×
          </button>
        </div>
        <ol>
          <li>Forward your recruiting emails to: <strong>wizrecruitmain@gmail.com</strong>.</li>
          <li>Press <strong>Import Players</strong> and wait a few minutes for your players to be added automatically.</li>
            <ul>
              <li>Players are also automatically imported every hour.</li>
            </ul>
          <li>Refresh or log in to view your updated recruits table.</li>
            <ul>
              <li>Filter, sort, rank and edit players as needed.</li>
              <li>For <strong>multisport</strong> recruiters, select your desired sport by clicking on <em>All</em> in the top left.</li>
            </ul>
          <li>
            Additional information can be viewed by clicking on a player including:
            <ul>
              <li>Recruit Profile</li>
              <li>Athletic and Academic Information</li>
              <li>Additional Contact Details</li>
            </ul>
          </li>
        </ol>
      </div>
    </>
  );
};
